<template>
  <v-container>
    <v-row>
      <v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          class="pa-0"
          large
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Wijzig locatie {{ location ? location.title : '' }}
          </v-card-title>

          <v-card-text v-if="loadError">
            <v-alert type="error">
              Kan de locatie niet laden. Probeer het opnieuw.
            </v-alert>
          </v-card-text>

          <v-card-text v-else-if="loaded">
            <location-address-form
              ref="addressForm"
              v-model="address"
            />

            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  :loading="saving"
                  @click="validateAndSave"
                >
                  Sla op
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

import { createBreadcrumbs } from '../../helpers/humanizer';
import LocationAddressForm from '../../components/locations/AddressForm.vue';

export default {
  name: 'LocationsEditPage',
  components: {
    LocationAddressForm,
  },
  data() {
    return {
      loaded: false,
      loadError: false,
      saving: false,
      location: null,
      address: {
        tav: null,
        toLocation: null,
        toStreet: null,
        toHouseNumber: null,
        toCity: null,
        toPostalCode: null,
        toCountry: 'NL',
      },
    };
  },
  computed: {
    breadcrumbs() {
      return createBreadcrumbs(
        this.$store.state.app.dashboardHomeName,
        [
          {
            text: 'Locaties',
            disabled: false,
            exact: true,
            to: { name: 'locations' },
          },
          {
            text: 'Locatie aanpassen',
            disabled: true,
            exact: true,
            to: { name: 'locationsEdit' },
          },
        ],
        false,
      );
    },
  },
  beforeMount() {
    this.loadLocation();
  },
  methods: {
    loadLocation() {
      const url = `${config.VUE_APP_API_BASE_URL}/locations/${this.$route.params.id}`;

      axios({
        url,
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.jwt}`,
        },
        method: 'get',
      })
        .then((response) => {
          this.location = response.data.location;

          if (this.location.address) {
            this.address = {
              ...this.address,
              ...this.location.address,
            };
          }

          this.loaded = true;
        })
        .catch(() => {
          this.loadError = true;
        });
    },
    validateAndSave() {
      const addressValid = this.$refs.addressForm.validate();
      if (!addressValid) return;

      this.saveAddress();
    },
    saveAddress() {
      const url = `${config.VUE_APP_API_BASE_URL}/locations/${this.$route.params.id}`;

      this.saving = true;

      axios({
        url,
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.jwt}`,
        },
        data: {
          address: this.address,
        },
        method: 'patch',
      })
        .then(() => {
          this.$store.commit('app/snackbarText', {
            text: `Locatie "${this.location.title}" aangepast`,
            visible: true,
          });

          this.$router.push({ name: 'locationsShow', params: { id: this.$route.params.id } });
        })
        .catch(() => {
          this.$store.commit('app/snackbarText', {
            text: 'Kan de locatie niet opslaan. Probeer het opnieuw.',
            visible: true,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
